


























































































































































































































import TransactionService from '@/services/TransactionService';
import { Component, Vue } from 'vue-property-decorator';

const transactionService = new TransactionService();

@Component
export default class Transfer extends Vue {
  public withdrawAccountFormloading: boolean = false;

  public savingAccountFormLoading: boolean = false;

  public amount: number = 0;

  public depositAccountBalance: number | string = 'X.XX';

  public withdrawAccountBalance: number | string = 'X.XX';

  public depositAccountLoading: boolean = false;

  public withdrawAccountLoading: boolean = false;

  async transferMoneyToWithdrawAccount() {
    this.withdrawAccountFormloading = true;
    try {
      await transactionService.transferMoneyToWithdrawAccount(this.amount);
      this.$store.commit('Snackbar/showNotification', { message: 'ดำเนินการสำเร็จ', error: false });
    } catch (e) {
      this.$store.commit('Snackbar/showNotification', { message: e.message, error: true });
    }
    this.amount = 0;
    this.withdrawAccountFormloading = false;
  }

  async transferMoneyToSavingAccount() {
    this.savingAccountFormLoading = true;
    try {
      await transactionService.transferMoneyToSavingAccount(this.amount);
      this.$store.commit('Snackbar/showNotification', { message: 'ดำเนินการสำเร็จ', error: false });
    } catch (e) {
      this.$store.commit('Snackbar/showNotification', { message: e.message, error: true });
    }
    this.amount = 0;
    this.savingAccountFormLoading = false;
  }

  async getDepositAccountBalance() {
    this.depositAccountLoading = true;
    try {
      const { data } = await transactionService.getBalance('deposit');
      this.depositAccountBalance = data.balance;
    } catch (e) {
      this.$store.commit('Snackbar/showNotification', { message: e.message, error: true });
    }
    this.depositAccountLoading = false;
  }

  async getWithdrawAccountBalance() {
    this.withdrawAccountLoading = true;
    try {
      const { data } = await transactionService.getBalance('withdraw');
      this.withdrawAccountBalance = data.balance;
    } catch (e) {
      this.$store.commit('Snackbar/showNotification', { message: e.message, error: true });
    }
    this.withdrawAccountLoading = false;
  }
}
